export const INELIGIBLE_CUSIPS = [
  '921937686',
  '92203J100',
  '921909818',
  '92203J308',
  '921937710',
  '92206C888',
  '921908828',
  '922031506',
  '922042734',
  '68381K101',
  '68381K200',
  '68381K309',
  '68381K606',
  '68381K507',
  '68381K408',
  '38142B872',
  '47103E668',
  '001413137',
  '00142C771',
  '02630R401',
  '02630R781'
];

export const isIneligibleCusip = cusip => {
  return INELIGIBLE_CUSIPS.includes(cusip) || cusip === undefined;
};

export const transformIntoQuickSearchFunds = funds =>
  Array.isArray(funds) &&
  funds.map(fund => ({
    ...fund,
    name: fund.name || '',
    ticker: fund.symbolCode || ''
  }));

const getSelectedCustodianFundDetails = (fundName, fundQuickSearchFunds) => {
  return fundQuickSearchFunds.find(f => f.name === fundName);
};

const cleanTicker = value => value.replace(/\(.*/gi, '');

export const updateCusips = (
  idx,
  value,
  fundQuickSearchFunds,
  cusips,
  setCusips
) => {
  let cusip = '';
  const updatedCusips = [...cusips];
  // Remove the ticker from value
  const selectedVal = cleanTicker(value).trim();
  // Retreive InvestmentVehicle details for the fund
  const investmentObj = getSelectedCustodianFundDetails(
    selectedVal,
    fundQuickSearchFunds
  );
  if (investmentObj !== undefined) {
    cusip = isIneligibleCusip(investmentObj?.cusip) ? '' : investmentObj?.cusip;
  }
  updatedCusips[idx] = cusip;
  setCusips(updatedCusips);
};
